import React from 'react';
import { SectionWrapper } from '../../hoc';
//import { img4, cory, male, female, lili, joe, alvin, makayla, trey, wade } from '../../assets';
import './Programs.css';

function Programs() {
  return (
    <>
      <div className="body-team">
        <div className="team">

          <h1>Remodelling CEB...</h1>

          {/* 
          Original formatting:
          <div className="content-team-top">
            <div className="card-team1">
              <div className="box-team">
                <img src={female} alt="Janae Dotson" />
              </div>
              <div className="info-team">
                <div className="name-team">Janae Dotson</div>
                <div className="details-team">President</div>
                <div className="emails-team">nsbelatech.chair@gmail.com</div>
              </div>
            </div>
          */} 

          <div class="loader">
          </div>

        </div>
      </div>
    </>
  );
}

export default SectionWrapper(Programs, 'programs');
